// extracted by mini-css-extract-plugin
export default {"not__paragraph":"NotFoundPage_not__paragraph__oPJsd","not__img":"NotFoundPage_not__img__g17Nv"};